import { render, staticRenderFns } from "./CCalendarServicePanel.vue?vue&type=template&id=d18857f0&scoped=true"
import script from "./CCalendarServicePanel.vue?vue&type=script&lang=ts"
export * from "./CCalendarServicePanel.vue?vue&type=script&lang=ts"
import style0 from "./CCalendarServicePanel.vue?vue&type=style&index=0&id=d18857f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18857f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
